import { useAppState } from '../../AppStateProvider';
import { useCompanyQuery } from '../../features/company/useCompanyQuery';
import { useIsWithinCrm } from '../../hooks/useIsWithinCrm';
import { useIsWithinLinkedin } from '../../hooks/useIsWithinLinkedin';
import UrlService from '../../services/UrlService';

import { EmptyPageVariant } from './types';

const crmEmptyStateConfig = {
  [EmptyPageVariant.HubSpot]: {
    img: '/images/empty-state-lens.svg',
    variant: 'lens-rised',
    messageKey: 'company.empty_state.crm.hubspot.message',
  },
  [EmptyPageVariant.MicrosoftDynamics]: {
    img: '/images/empty-state-lens.svg',
    variant: 'lens-rised',
    messageKey: 'company.empty_state.crm.message',
  },
  [EmptyPageVariant.Salesforce]: {
    img: '/images/empty-state-lens.svg',
    variant: 'lens-rised',
    messageKey: 'company.empty_state.crm.message',
  },
};

const mapCrmUrlToEmptyStatePageConfig = (urlString: string) => {
  const url = UrlService.createEventUrl(urlString);

  if (UrlService.isHubspotUrl(url)) {
    return crmEmptyStateConfig[EmptyPageVariant.HubSpot];
  }
  if (UrlService.isMicrosoftDynamicsUrl(url)) {
    return crmEmptyStateConfig[EmptyPageVariant.MicrosoftDynamics];
  }
  if (UrlService.isSalesforceUrl(url) || UrlService.isSalesforceLightningUrl(url)) {
    return crmEmptyStateConfig[EmptyPageVariant.Salesforce];
  }
};

export const useCompanyEmptyState = () => {
  const { url } = useAppState();
  const companyQuery = useCompanyQuery();
  const isWithinLinkedin = useIsWithinLinkedin();
  const isWithinCrm = useIsWithinCrm();

  const isEmptyState = companyQuery.isSuccess && !companyQuery.data;

  const emptyStateProps = isWithinCrm ? mapCrmUrlToEmptyStatePageConfig(url!) : {};

  return {
    isEmptyState: isEmptyState && !isWithinLinkedin,
    emptyStateProps,
  };
};
